/* eslint-disable import/prefer-default-export */
import COLORS from '$variables/colors';

const looks = {
  default: {
    color: COLORS.white,
  },
  green: {
    color: COLORS.green,
  },
};

export { looks };
